import React, { useEffect, useState, useRef } from "react";
import Table from "react-bootstrap/Table";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { connect, useDispatch } from "react-redux";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { withRouter } from "../../../App";
import AddJobComponent from "./AddJob";
import { dateFormat } from "../../../utils/date";
import Status from "../Common/Status";
import { getCompanyJob } from "../../../store/actions/Jobs/jobActions";
import { del } from "../../../services/api";
import EditJobComponent from "./EditJob";

const Jobs = ({ jobs, selectedCompany, token, isView }) => {
  const dispatch = useDispatch();
  const companyJobRef = useRef();
  const companyJobEditRef = useRef();
  return (
    <div>
      {/* {!isView && (
        <button
          className="btn btn-danger mb-3"
          onClick={() => {
            companyJobRef.current.showAddJobModal();
          }}
        >
          <i className="fa fa-plus"></i> Add Job
        </button>
      )} */}

      <Table responsive className="table table-responsive">
        <thead>
          <tr>
            <th>
              <strong>Job ID</strong>
            </th>
            <th>
              <strong>Job Title</strong>
            </th>
            {/* <th>
              <strong>Salary</strong>
            </th> */}

            <th>
              <strong>Start Date</strong>
            </th>
            <th>
              <strong>End Date</strong>
            </th>

            <th>
              <strong>Service</strong>
            </th>
            <th>
              <strong>Status</strong>
            </th>
            {!isView && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {jobs?.length === 0 && (
            <tr>
              <td colSpan={6}>No result found.</td>
            </tr>
          )}
          {jobs?.map((row, index) => (
            <tr key={index}>
              <td>{row?.jobID || "--"}</td>

              <td>
                <strong>{row?.jobTitle}</strong>
              </td>
              {/* <td>{row?.salary || "--"}</td> */}
              <td>
                {row?.jobStartDate ? dateFormat(row?.jobStartDate) : "--"}
              </td>
              <td>{row?.jobEndDate ? dateFormat(row?.jobEndDate) : "--"}</td>
              <td>{row?.service || "--"}</td>
              <td>
                <Status status={row?.status || "--"} />
              </td>
              {!isView && (
                <td>
                  <div className="d-flex">
                    <>
                      <button
                        type="button"
                        className="btn btn-primary shadow btn-xs sharp me-1"
                        onClick={() => {
                          companyJobEditRef.current.showEditJobModal(row);
                        }}
                      >
                        <i className="fas fa-pencil-alt"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger shadow btn-xs sharp"
                        onClick={(e) => {
                          e.preventDefault();
                          swal({
                            title: "Are you sure?",
                            text: "Once deleted, you will not be able to recover this company job!",
                            icon: "warning",
                            buttons: true,
                            confirmButtonText: "Delete",
                            dangerMode: true,
                          }).then(async (willDelete) => {
                            if (willDelete) {
                              await del("/api/job/" + row?._id, token);
                              toast.success(
                                "Company job has been deleted successully."
                              );
                              dispatch(
                                getCompanyJob(selectedCompany?._id, token)
                              );
                            } else {
                            }
                          });
                        }}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
      <AddJobComponent
        ref={companyJobRef}
        Title="Add Job"
        companyId={selectedCompany?._id}
        companyName={selectedCompany?.companyName}
        token={token}
      />
      <EditJobComponent
        ref={companyJobEditRef}
        Title="Edit Job"
        companyId={selectedCompany?._id}
        companyName={selectedCompany?.companyName}
        token={token}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    selectedCompany: state.companies.selectedCompany,
    jobs: state.jobs.jobList,
  };
};

export default withRouter(connect(mapStateToProps)(Jobs));
